/**
 * Trims, normalizes to NFC form, and lowercases a string for consistent text
 * comparison.
 */
export function toComparableString(s: string): string {
  return s.trim().normalize("NFC").toLowerCase();
}

export function includesSearch(value: string, search: string): boolean {
  return toComparableString(value).includes(toComparableString(search));
}
